import { INSTRUCTION_SENDER_MAX_LENGTH } from '@/components/constants';
import { InstructionPdfForm } from '@/features/ap_payees/components/DocInstructionMenu/types';
import { useTranslation } from '@/i18n';
import { FormTextArea, Label } from '@moneyforward/ap-frontend-components';
import { FC, memo, useMemo } from 'react';
import { Control } from 'react-hook-form';
import styles from '../styles.module.scss';
import { validationRules } from '@/features/ap_payees/components/DocInstructionMenu/Helpers/validationRules';

export type TInstructionSenderProps = {
  control: Control<InstructionPdfForm>;
};

export const InstructionSender: FC<TInstructionSenderProps> = memo(
  ({ control }) => {
    const { t } = useTranslation();

    const senderRules = useMemo(
      () => ({
        required: {
          value: true,
          message: t('common.validation.required'),
        },
        validate: validationRules.requiredNotAllowEmpty(
          t('common.validation.required')
        ),
        maxLength: {
          value: INSTRUCTION_SENDER_MAX_LENGTH,
          message: t('common.validation.max_length', {
            maxLength: INSTRUCTION_SENDER_MAX_LENGTH,
          }),
        },
      }),
      [t]
    );

    const senderProps = useMemo(
      () => ({
        style: {
          height: '48px',
          minHeight: '48px',
        },
      }),
      []
    );

    return (
      <div className={styles.row}>
        <div className={styles.label}>
          <Label text={t('export_instruction_pdf_sender')} htmlFor='sender' />
        </div>
        <div className={styles.content}>
          <FormTextArea<InstructionPdfForm>
            name='sender'
            textAreaProps={senderProps}
            control={control}
            inputId='sender'
            rules={senderRules}
          />
        </div>
      </div>
    );
  }
);

InstructionSender.displayName = 'InstructionSender';
